export default __webpack_public_path__ + "static/media/dealer-methods_tile.png";